var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headerH5"},[_c('div',{staticClass:"logo",on:{"click":_vm.goto}},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/logoH5.png"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"menu-box",on:{"click":_vm.setShow}},[_c('div',{staticClass:"img-menu",class:_vm.show ? 'active' : ''})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9725f60","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/h5/headerH5.vue
// module id = null
// module chunks = 